import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Layout, 
  Card, 
  Typography, 
  Button, 
  Space, 
  Result
} from 'antd';
import { 
  ArrowLeftOutlined,
  CreditCardOutlined
} from '@ant-design/icons';
import { useApp } from '../context/AppContext';

const { Content } = Layout;
const { Title } = Typography;

const OperationsPage = () => {
  const navigate = useNavigate();
  const { t } = useApp();

  useEffect(() => {
    if (window.Telegram?.WebApp?.MainButton) {
      try {
        window.Telegram.WebApp.MainButton.hide();
      } catch (error) {
        console.warn('MainButton hide error:', error);
      }
    }
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Layout>
      <Content style={{ padding: '16px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          
          <Card>
            <Space>
              <Button 
                type="text" 
                icon={<ArrowLeftOutlined />} 
                onClick={handleBack}
              >
                {t('ops_back')}
              </Button>
              <Title level={3} style={{ margin: 0 }}>
                {t('ops_title')}
              </Title>
            </Space>
          </Card>

          <Card>
            <Result
              icon={<CreditCardOutlined />}
              title={t('ops_page_title')}
              subTitle={t('ops_page_subtitle')}
              extra={
                <Button type="primary" onClick={handleBack}>
                  {t('ops_back_home')}
                </Button>
              }
            />
          </Card>
          
        </Space>
      </Content>
    </Layout>
  );
};

export default OperationsPage;
